function _bt(){return window.location.origin+window.location.pathname}
(function(){
  document.addEventListener('DOMContentLoaded',function(){
    const _bu=document.querySelectorAll('.price');
    window._bv="";
    window._bw=null;
    window._bx="left";
    _bu.forEach(function(_by){
      let _bz=_by.getAttribute('data-vendor');
      if(_bz){
        _bz=_bz.toLowerCase();
        const _ca=_by.querySelectorAll('.price-item');
        _ca.forEach(function(_cb){
          let _cc=_cb.textContent.match(/[\d,.]+/);
          if(_cc){
            let _cd=parseFloat(_cc[0].replace(/,/g,''));
            if(_bz.includes("gha")){
              window._bv="GH₵";
              window._bx="left";
              window._bw=(_ce)=>_ce.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2,useGrouping:true});
            }else if(_bz.includes("nga")){
              window._bv="₦";
              window._bx="left";
              window._bw=(_ce)=>_ce.toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:0,useGrouping:true});
            }else if(_bz.includes("cfa")){
              window._bv="CFA";
              window._bx="right";
              window._bw=(_ce)=>_ce.toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:0,useGrouping:true});
            }else if(_bz.includes("gin")){
              window._bv="GNF";
              window._bx="left";
              window._bw=(_ce)=>_ce.toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:0,useGrouping:true});
            }else if(_bz.includes("rdc")){
              window._bv="$";
              window._bx="left";
              window._bw=(_ce)=>_ce.toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:0,useGrouping:true});
            }else if(_bz.includes("ken")){
              window._bv="KSh";
              window._bx="left";
              window._bw=(_ce)=>_ce.toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:0,useGrouping:true});
            }else if(_bz.includes("ksa")){
              window._bv="ريال سعودي";
              window._bx="right";
              window._bw=(_ce)=>_ce.toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:0,useGrouping:true});
            }
            if(window._bw){
              let _cf=_cg(_cd);
              _cb.textContent=_cf;
            }
          }
        });
      }
      _by.classList.add('price--formatted');
    });
  });
})();

window._cg=function(_ch,_ci={}){
  const{useSymbol=true,useOriginalFormat=true}=_ci;
  let _cj;
  if(useOriginalFormat&&typeof window._bv!=='undefined'&&window._bv.trim()!==''&&typeof window._bw==='function'){
    _cj=window._bw(parseFloat(_ch));
  }else{
    _cj=parseFloat(_ch).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
  }
  if(!useSymbol){return _cj;}
  if(typeof window._bv!=='undefined'&&window._bv.trim()!==''){
    if(window._bx==="right"){
      return`${_cj} ${window._bv}`;
    }else{
      return`${window._bv} ${_cj}`;
    }
  }else if(typeof moneyFormat!=='undefined'&&moneyFormat){
    return moneyFormat.replace(/\{\{amount\}\}/g,_cj);
  }else{
    return`$${_cj}`;
  }
}

function _ck(){
  document.body.style.overflow='hidden';
  document.body.style.height='100%';
}

function _cl(){
  document.body.style.overflow='';
  document.body.style.height='';
}

function _cm(_cn,_co={}){
  let _cp=window.translations&&window.translations[_cn]?window.translations[_cn]:_cn;
  Object.keys(_co).forEach(_cq=>{
    _cp=_cp.replace(`{${_cq}}`,_co[_cq]);
  });
  return _cp;
}

document.addEventListener('DOMContentLoaded',function(){
  var _cr=document.getElementById('_ag');
  var _cs=document.getElementById('_a');
  var _ct=document.getElementById('_ai');
  var _cu=document.getElementById('_as');
  var _cv=document.getElementById('_custom-upsell-popup-wrapper');
  var _cw=document.getElementById('_al');
  var _cx=document.getElementById('_aw');
  var _cy=document.getElementById('_bl');
  var _cz=document.getElementById('_bo');
  var _da="{{ money_format | escape }}";
  const _db=true;
  const _dc=true;
function trySendFBPixelEvent(eventName, data = {}) {
  if (typeof window.sendFBPixelEvent === 'function') {
    window.sendFBPixelEvent(eventName, data);
  } else {
    console.error('sendFBPixelEvent function not found. Make sure the Facebook Pixel is properly initialized.');
  }
}
    trySendFBPixelEvent('ViewContent',{
      content_name:productTitle,
      content_type:'product',
      content_ids:[productId],
      value:productPrice,
      currency:shopCurrency
    });

  var _dd=true;
  if(_cu&&_cv){_cv.appendChild(_cu);}
  if(_cr){
    _cr.addEventListener('click',function(){
      if(_cs){
        _cs.style.display='block';
        _ck();
        trySendFBPixelEvent('InitiateCheckout');
        if(_dc){trySendFBPixelEvent('AddToCart');}
      }else{
        console.error('Modal not found');
      }
    });
  }else{
    console.error('Buy Now button not found');
  }
  if(_cw&&_ct){
    _cw.addEventListener('click',function(){
      _ct.style.display='none';
      _cl();
    });
  }
  if(_cx&&_cu){
    _cx.addEventListener('click',function(){
      window._de(true);
    });
  }
  if(_cy){_cy.addEventListener('click',window._bn);}
  if(_cz){_cz.addEventListener('click',window._bq);}
  var _df=quantityOffers;
  var _dg=productFeaturedImage;
  var _dh=upsellProductHandle;
  window._di={
    _dj:{},
    _dk:function(_dl){
      this._dj=Object.fromEntries(_dl);
      this._dj.product_title=productTitle;
      this._dj.price=productPrice;
      this._dj.variant_id=productVariantId;
      this._dj.product_url=_bt();
      var _dm=document.querySelector('input[name="selected_offer"]:checked');
      if(_dm){
        this._dj.quantity=_dm.value;
        this._dj.price=_dm.dataset.price;
      }else{
        this._dj.quantity=document.getElementById("_y").value;
      }
    },
    _dn:function(){
      if(_dh){
        fetch('/products/'+_dh+'.js')
          .then(_do=>_do.json())
          .then(_dp=>{
            this._dj.upsell_variant_id=_dp.variants[0].id;
            this._dj.upsell_quantity=_dd?parseInt(document.getElementById('_bg').value):1;
            this._dj.upsell_price=_dp.variants[0].price/100;
            this._dj.upsell_title=_dp.title;
            window._de();
            this._dq();
          })
          .catch(_dr=>{
            console.error('Error fetching upsell product:',_dr);
            this._dq();
          });
      }else{
        this._dq();
      }
    },
    _ds:function(){
      window._de();
      this._dq();
    },
    _dq:function(){
      window._dt();
      var _du="https://5914x880m3.execute-api.eu-north-1.amazonaws.com/prod/order";
      var _dv=this._dj;
      _dv.price=parseFloat(_dv.price);
      _dv.quantity=parseInt(_dv.quantity);
      if(_dv.upsell_price){
        _dv.upsell_price=parseFloat(_dv.upsell_price);
        _dv.upsell_quantity=parseInt(_dv.upsell_quantity);
      }

      fetch(_du,{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify(_dv),
      }).then((_dw)=>{
        return _dw.json();
      }).then((_dx)=>{
        if(_dx.error){throw new Error(_dx.error);}
        window._dy();
        this._dz();
        if(_db){
          trySendFBPixelEvent('Lead');
        }else{
          trySendFBPixelEvent('Purchase',{
            currency:_dx.currency||'XOF',
            value:_dx.total_price||(_dv.price*_dv.quantity),
          });
        }
      }).catch((_ea)=>{
        console.error("Error:",_ea);
        window._eb(_ea.message);
      });
    },
    _dz:function(){
      var _ec=document.getElementById("_h");
      var _ed=document.getElementById("_y");
      _ec.reset();
      _ed.value="1";
      document.querySelectorAll("._by").forEach(function(_ee){
        _ee.classList.remove("_bz");
        _ee.style.backgroundColor=_ee.dataset.backgroundColor;
      });
      if(document.querySelector("._by")){
        const _ef=document.querySelector("._by");
        _ef.classList.add("_bz");
        _ef.style.backgroundColor=_ef.dataset.selectedBackgroundColor;
        _ef.querySelector('input[type="radio"]').checked=true;
      }
      this._dj={};
    }
  };
  window._bn=function(){window._di._dn();};
  window._bq=function(){window._de(true);};
  function _eg(_eh){
    var _ei=document.getElementById('_ai');
    var _ej=_ei.querySelectorAll('._ak > div');
    var _ek=document.getElementById('_al');
    _ej.forEach(function(_el){_el.classList.remove('active');});
    var _em=document.getElementById(_eh);
    if(_em){_em.classList.add('active');}
    _ei.style.display='flex';
    _ck();
    if(_eh==='_an'){
      _ek.style.display='none';
    }else{
      _ek.style.display='block';
    }
  }
  window._dt=function(){_eg('_an');};
  window._dy=function(){_eg('_ao');};
  window._eb=function(_en){
    var _eo=document.getElementById('_ar');
    if(_eo){_eo.textContent=_en;}
    _eg('_aq');
  };
  window._ep=function(){
    var _eq=document.getElementById('_as');
    var _er=_eq.getAttribute('data-upsell-handle');
    if(_er){
      fetch('/products/'+_er+'.js')
        .then(_es=>_es.json())
        .then(_et=>{
          document.getElementById('_ay').textContent=_cm('upsell_title',{product_title:_et.title});
          document.getElementById('_az').src=_et.featured_image;
          document.getElementById('_bb').innerHTML=_eu(_et.description,1000000);
          document.getElementById('_bd').textContent=_cg(_et.compare_at_price/100);
          document.getElementById('_be').textContent=_cg(_et.price/100);
          var _ev=document.getElementById('_bf');
          if(_ev){_ev.style.display=_dd?'block':'none';}
          var _ew=document.getElementById('_bg');
          if(_ew){_ew.value='1';}
          _eq.style.display='flex';
          document.getElementById('_ba').scrollTop=0;
          _ck();
        })
        .catch(_ex=>{
          console.error('Error fetching upsell product:',_ex);
          window._bq();
        });
    }else{
      window._bq();
    }
  };
  window._de=function(_ey=false){
    var _ez=document.getElementById('_as');
    if(_ez){_ez.style.display='none';}
    _cl();
    if(_ey){window._di._dq();}
  };
  function _eu(_fa,_fb){
    const _fc=new DOMParser();
    const _fd=_fc.parseFromString(_fa,'text/html');
    const _fe=_fd.body;
    let _ff=0;
    let _fg=false;
    function _fh(_fi){
      if(_fg)return;
      if(_fi.nodeType===Node.TEXT_NODE){
        if(_ff+_fi.length>_fb){
          _fi.textContent=_fi.textContent.slice(0,_fb-_ff)+'...';
          _fg=true;
          return;
        }
        _ff+=_fi.length;
      }else if(_fi.nodeType===Node.ELEMENT_NODE){
        if(_fi.nodeName==='IMG'){
          _ff+=_fi.alt.length;
        }else{
          let _fj=Array.from(_fi.childNodes);
          for(let _fk of _fj){
            _fh(_fk);
            if(_fg){
              while(_fk.nextSibling){
                _fi.removeChild(_fk.nextSibling);
              }
              break;
}
          }
        }
      }
    }
    _fh(_fe);
    return _fe.innerHTML;
  }
  function _fl(){
    var _fm=document.getElementById("_y");
    var _fn=document.getElementById("_ac");
    var _fo=document.getElementById("_aa");
    if(_fn&&_fm){
      _fn.addEventListener('click',function(){
        _fm.value=parseInt(_fm.value)+1;
      });
    }
    if(_fo&&_fm){
      _fo.addEventListener('click',function(){
        if(parseInt(_fm.value)>1){
          _fm.value=parseInt(_fm.value)-1;
        }
      });
    }
    var _fp=document.getElementById('_bg');
    var _fq=document.getElementById('_bj');
    var _fr=document.getElementById('_bh');
    if(_fq&&_fp){
      _fq.addEventListener('click',function(){
        _fp.value = parseInt(_fp.value) + 1;
      });
    }
    if(_fr&&_fp){
      _fr.addEventListener('click',function(){
        if(parseInt(_fp.value)>1){
          _fp.value=parseInt(_fp.value)-1;
        }
      });
    }
  }
  _fl();
  var _fs=document.getElementById("_a");
  var _ft=document.getElementById("_custom-cod-form-modal-wrapper");
  var _fu=document.getElementById("_f");
  var _fv=document.getElementById("_h");
  var _fw=document.getElementById("_l");
  var _fx=document.getElementById("_v");
  var _fy=document.getElementById("_aa");
  if(_fs&&_ft){_ft.appendChild(_fs);}
  function _fz(){
    _fs.style.display="flex";
    _ck();
  }
  function _ga(){
    _fs.style.display="none";
    _cl();
  }
  _fu.addEventListener("click",_ga);
  if(typeof _df!=="undefined"&&_df!==""){
    try{
      var _gb=JSON.parse(_df.replace(/&quot;/g,'"'));
      if(Array.isArray(_gb)&&_gb.length>0){
        _fw.innerHTML=`<h3>${_cm('choose_offer')}</h3>`;
        _gb.forEach(function(_gc,_gd){
          var _ge=document.createElement("div");
          _ge.className="_by";
          _ge.style.backgroundColor=_gc.background_color||"#ffffff";
          _ge.dataset.backgroundColor=_gc.background_color||"#ffffff";
          _ge.dataset.selectedBackgroundColor=_gc.selected_background_color||"#E6F3FF";
          _ge.innerHTML=`
            <input type="radio" id="offer-${_gc.quantity}" name="selected_offer" value="${_gc.quantity}" data-price="${_gc.price}" ${_gd===0?'checked':''}>
            <label for="offer-${_gc.quantity}">
              <img src="${_dg}" alt="Product Image" class="_gf">
              <div class="_gg">
                <div class="_gh">
                  <span class="_gi" style="color: ${_gc.title_color};">${_gc.title}</span>
                </div>
                <div class="_gj">
                  <span class="_gk" style="background-color: ${_gc.badge_color};">${_gc.badge}</span>
                </div>
              </div>
              <div class="_gl">
                <span class="_gm">${_cg(_gc.original_price)}</span>
                <span class="_gn" style="color: ${_gc.price_color};">${_cg(_gc.price)}</span>
              </div>
            </label>
          `;
          _fw.appendChild(_ge);
          _ge.addEventListener("click",function(){
            document.querySelectorAll("._by").forEach(function(_go){
              _go.classList.remove("_bz");
              _go.style.backgroundColor=_go.dataset.backgroundColor;
            });
            this.classList.add("_bz");
            this.style.backgroundColor=this.dataset.selectedBackgroundColor;
            this.querySelector('input[type="radio"]').checked=true;
          });
        });
        if(document.querySelector("._by")){
          const _gp=document.querySelector("._by");
          _gp.classList.add("_bz");
          _gp.style.backgroundColor=_gp.dataset.selectedBackgroundColor;
          _gp.querySelector('input[type="radio"]').checked=true;
        }
        _fx.style.display="none";
        _fw.style.display="block";
      }else{
        _fw.style.display="none";
        _fx.style.display="block";
      }
    }catch(_gq){
      console.error("Error parsing quantity offers:",_gq);
      _fw.style.display="none";
      _fx.style.display="block";
    }
  }else{
    _fw.style.display="none";
    _fx.style.display="block";
  }
  _fv.addEventListener("submit",function(_gr){
    _gr.preventDefault();
    window._di._dk(new FormData(_fv));
    _ga();
    if(_dh&&typeof window._ep==='function'){
      window._ep();
    }else{
      window._di._dq();
    }
  });
});

document.addEventListener('DOMContentLoaded',function(){
  var _gs=document.querySelector('._ag:not(._bs)');
  var _gt=document.getElementById('_br');
  var _gu=document.getElementById('_a');
  function _gv(){
    var _gw=_gs.getBoundingClientRect();
    var _gx=window.innerHeight||document.documentElement.clientHeight;
    var _gy=(_gw.top>=0&&_gw.bottom<=_gx);
    if(!_gy&&window.pageYOffset>_gw.bottom){
      _gt.style.display='flex';
    }else{
      _gt.style.display='none';
    }
  }
  window.addEventListener('scroll',_gv);
  window.addEventListener('resize',_gv);
  setTimeout(_gv,100);
  _gt.addEventListener('click',function(){
    if(_gu){
      _gu.style.display='block';
    }else{
      console.error('Modal not found');
    }
  });
});